import { EMPLOYEE_PAYROLL_SUCCESS } from "../constants";

export default function(state = {}, action) {
  switch (action.type) {
  case EMPLOYEE_PAYROLL_SUCCESS:
    return {
      ...state,
      [action.id]: action.payload
    };
  default:
    return state;
  }
}